import React from 'react';
import './ModelSelector.css'; // 样式文件

const ModelSelector = ({ models, onSelect, selectedModels, disabled }) => {
    const handleClick = (modelValue) => {
        if (!disabled) {
            onSelect(modelValue);
        }
    };

    return (
        <div className={`ModelSelector ${disabled ? 'disabled' : ''}`}>
            <ul>
                <li
                    className={`model-item ${selectedModels.length === models.length ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
                    onClick={() => handleClick('All-In-One')}
                >
                    All-In-One
                </li>
                <hr className="model-separator"/>
                {models.map((model) => (
                    <li
                        key={model.value}
                        className={`model-item ${selectedModels.includes(model.value) ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
                        onClick={() => handleClick(model.value)}
                    >
                        <img
                            src={model.icon}
                            alt={model.label}
                            className="model-icon-img"
                            style={{width: '20px', height: '20px', marginRight: '5px'}}
                        />
                        {model.label}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ModelSelector;

